var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " more-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 4.66667C8.7373 4.66667 9.33464 4.06933 9.33464 3.33333C9.33464 2.59733 8.7373 2 8.0013 2C7.2653 2 6.66797 2.59733 6.66797 3.33333C6.66797 4.06933 7.2653 4.66667 8.0013 4.66667ZM8.0013 6.66665C7.2653 6.66665 6.66797 7.26398 6.66797 7.99998C6.66797 8.73598 7.2653 9.33331 8.0013 9.33331C8.7373 9.33331 9.33464 8.73598 9.33464 7.99998C9.33464 7.26398 8.7373 6.66665 8.0013 6.66665ZM6.66797 12.6666C6.66797 11.9306 7.2653 11.3333 8.0013 11.3333C8.7373 11.3333 9.33464 11.9306 9.33464 12.6666C9.33464 13.4026 8.7373 14 8.0013 14C7.2653 14 6.66797 13.4026 6.66797 12.6666Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/MoreVertical.5ca707624bd9c136359c78f11e768cca.svg";
export { ForwardRef as ReactComponent };